import { isNextStatusWorseOrSame } from './checkStatus';

// filter only sensors that are not actuators
export const nonActuatorSensorFilter = s => !s.device_id;

export const flatMapFeatures = feature => {
  if (Array.isArray(feature.features) && feature.type !== 'composite')
    return feature.features.flatMap(flatMapFeatures);
  return feature;
};

export const getActuatorStatus = features => {
  return (
    features
      .map(f => f.reading?.status)
      .filter(Boolean)
      .reduce((result, curr) => {
        if (!result || isNextStatusWorseOrSame(result, curr)) return curr;
        return result;
      }, null) ?? 'OFF'
  );
};
